<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import NextStepsChart from '#/detailsReport/NextStepsChart'
import AppButton from '#/general/AppButton'
import { computed, inject } from 'vue'

const { global, application, pages } = inject('Shared')
const { lead, partnerWidgetLead, version } = useDetailsReport()
function scrollIntoCta () {
  let element
  if (application === 'WIDGET') {
    if (process.env.NODE_ENV === 'production') {
      const shadow = document.querySelector('#app').shadowRoot
      element = shadow.querySelector('#ctaSection')
    } else {
      element = document.getElementById('ctaSection')
    }
  } else {
    element = document.getElementById('ctaSection')
  }
  element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
}

const direction = computed(() => {
  if (version.value === 1) {
    return 'column-reverse'
  }
  return 'column'
})
</script>
<template lang="pug">
.explanationContainer(v-if="version === 1")
  .textContainer
    .textsContent
      .firstText {{ pages.detailReport.firstSteps.explanation.firstText }}
      .secondText {{ pages.detailReport.firstSteps.explanation.secondText }}
    app-button.inquiry-btn(
      v-if="version === 1"
      label="Jetzt anfragen"
      @clicked="scrollIntoCta"
      :bg-color="global.buttonBackground"
      :bg-hover="global.buttonBackgroundHover"
      :label-color="global.buttonColor"
    )
  div(:class="version === 1 ? 'stepsContainer' : ''")
    next-steps-chart
</template>

<style scoped lang="sass">
.explanationContainer
  position: relative
  background: white
  width: 100%
  display: flex
  @media screen and (min-width: 1440px)
    flex-direction: row
    margin-top: 30px
  @media screen and (max-width: 1440px)
    display: flex
    align-items: center
    justify-content: center
    flex-direction: v-bind(direction)
    margin-top: 10px
  .textContainer
    max-width: 100%
    display: flex
    flex-direction: column
    @media screen and (min-width: 1440px)
      width: 350px !important
      padding-right: 59px
    @media screen and (max-width: 1440px)
      width: 100%
      padding: 15px 0
    .textsContent
      @media screen and (min-width: 1440px)
        flex: 1
      @media screen and (max-width: 1440px)
        width: 100%
      .firstText
        font-weight: 500
        font-size: 16px
        display: flex
        align-items: center
        color: #22223C
        line-height: 150%
      .secondText
        line-height: 150%
        font-weight: 500
        font-size: 16px
        display: flex
        align-items: center
        color: v-bind('global.graphicElementColor')
        margin: 20px 0
  .stepsContainer
    display: flex
    justify-content: center
    align-items: center
  .inquiry-btn
    width: 208px
    height: 54px
</style>
